<template>
  <div
    :style="{
      'background-image':
        'linear-gradient(rgba(0, 0, 0, 0.833) 0%, rgba(0, 0, 0, 0.714) 100%), url(' +
        this.movie.MovieImageUrl +
        ')',
    }"
    class="buy"
  >
    <div class="buy-header">
      <!-- <div class="logo"></div> -->
      <div class="timer">
        <div class="timer-label">Осталось</div>

        <div class="timer-time">
          <Timer
            :endtime="this.user.sessionEndAt"
            starttime="Sep 4, 2018 18:00:00"
            trans='{
           "day":"Дней",
           "hours":"Часов",
           "minutes":"Минут",
           "seconds":"Секунд",
           "expired":"Event has been expired.",
           "running":"До конца сессии",
           "upcoming":"С начала сессии",
           "status": {
              "expired":"Истек",
              "running":"Запущен",
              "upcoming":"Future"
             }}'
          ></Timer>
        </div>
      </div>
      <div class="contact" v-if="setting.supportPhone">
        <div class="contact-label">Служба поддержки</div>
        <div class="contact-number">{{ setting.supportPhone }}</div>
      </div>
      <div @click="goBack" class="button-back">
        <span class="btn-icon fa fa-long-arrow-left"></span>
      </div>
    </div>
    <div class="buy-body">
      <div class="buy-body-wrapper">
        <div
          :style="{
            'background-image':
              'linear-gradient(to bottom, #000000b3 0%, #000000b3 100%), url(' +
              this.movie.MovieImageUrl +
              ')',
          }"
          class="buy-session-wrapper"
        >
          <div class="buy-session-title" v-if="session.DateTime">
            {{ session.DateTime | moment('dddd, D MMMM в H:mm') }}
          </div>
          <div class="buy-session-footer">
            <div class="buy-session-tags">
              <div class="tag" v-if="session.Format">
                {{ session.Format.Name }}
              </div>
              <div class="tag">{{ movie.Rate }}</div>
            </div>
            <div class="buy-session-name">{{ session.MovieName }}</div>
          </div>
        </div>
        <div class="cart-wrapper">
          <div class="cart-wrapper-inner">
            <div
              class="cart-scrollable"
              :style="{
                'max-height':
                  (customer.accounts &&
                    setting.isBonusAvailable &&
                    user.gender &&
                    user.birthday &&
                    user.name &&
                    user.phone) ||
                  setting.donationShow
                    ? 'none'
                    : '25vh',
              }"
            >
              <div class="theatre-wrapper">
                <div class="label">Площадка</div>
                <div class="name" v-if="session.Hall">
                  {{ theatre.NameFull }}, {{ session.Hall.Name }}
                </div>
                <div class="address">{{ theatre.Address }}</div>
              </div>
              <div class="buy-cart cart-items">
                <div class="cart-group cart-ticket">
                  <div class="label">Билеты</div>
                  <div class="list">
                    <div
                      :key="index"
                      class="item"
                      v-for="(ticket, index) in cart.tickets"
                    >
                      <span class="position" v-if="!session.NoSeats"
                        >{{ ticket.row }} ряд {{ ticket.number }} место</span
                      >
                      <span class="position" v-else>{{ ticket.Name }}</span>
                      <span class="dots"></span>
                      <span class="price" v-if="ticket.price"
                        >{{ ticket.price }} {{ setting.currency }}</span
                      >
                      <span class="price" v-else>Бесплатно</span>
                    </div>

                    <div
                      :key="accountId"
                      v-for="accountId in customer.accountsList"
                      v-if="customer.accounts"
                    >
                      <div
                        class="item item_bonuses"
                        v-if="
                          customer.accounts[accountId].selected &&
                            customer.accounts[accountId].discount.tickets !== 0
                        "
                      >
                        <span class="position">{{
                          customer.accounts[accountId].type.name
                        }}</span>
                        <span class="dots"></span>
                        <span class="price"
                          >{{
                            customer.accounts[accountId].discount.tickets
                          }}
                          {{ setting.currency }}</span
                        >
                      </div>
                    </div>

                    <div class="item item_result">
                      <span class="position">Промежуточный итог</span>
                      <span class="dots"></span>
                      <span class="price"
                        >{{
                          cart.ticketSum - cart.spentBonuses.tickets
                        }}
                        {{ setting.currency }}</span
                      >
                    </div>
                  </div>
                </div>
                <div class="cart-group cart-bar" v-if="cart.bar.length">
                  <div class="label">Бар</div>
                  <div class="list">
                    <div
                      :key="index"
                      class="item"
                      v-for="(item, index) in cart.bar"
                    >
                      <span class="position"
                        >{{ item.name }} {{ item.size }} ({{
                          item.count
                        }}шт.)</span
                      >
                      <span class="dots"></span>
                      <span class="price"
                        >{{
                          getTotalPrice(item.price, item.count)
                        }}
                        {{ setting.currency }}</span
                      >
                    </div>

                    <div
                      :key="accountId"
                      v-for="accountId in customer.accountsList"
                      v-if="customer.accounts"
                    >
                      <div
                        class="item item_bonuses"
                        v-if="
                          customer.accounts[accountId].selected &&
                            customer.accounts[accountId].discount.bar !== 0
                        "
                      >
                        <span class="position">{{
                          customer.accounts[accountId].type.name
                        }}</span>
                        <span class="dots"></span>
                        <span class="price"
                          >{{
                            customer.accounts[accountId].discount.bar
                          }}
                          {{ setting.currency }}</span
                        >
                      </div>
                    </div>

                    <div class="item item_result">
                      <span class="position">Промежуточный итог</span>
                      <span class="dots"></span>
                      <span class="price"
                        >{{ cart.barSum - cart.spentBonuses.bar }} {{ setting.currency }}</span
                      >
                    </div>
                  </div>
                </div>

                <div class="cart-group cart-bar" v-if="cart.donations && user.paymentType !== 'pushkin'">
                  <div class="label">Поддержать кинотеатр</div>
                  <div class="list">
                    <div class="item">
                      <span class="dots"></span>
                      <span class="price">{{ cart.donations }} {{ setting.currency }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="cart-total">
            <div class="cart-total-label label">Итого:</div>
            <div class="cart-total-price">{{ cart.sum }} {{ setting.currency }}</div>
          </div>

          <!-- TODO раскоментить когда будет бонусная система -->
          <!-- <div class="cart-promo">
                      <div class="promo-btn" @click="show">
                        <div class="promo-label">
                          Бонусная карта
                        </div>
                      </div>
                    </div> -->
        </div>
      </div>
      <div class="payment-wrapper">
        <div class="payer-contact">
          <form class="form">
            <div class="step-box">
              <div class="step-box-label">1. Куда прислать заказ</div>
              <div class="step-box-inputs">
                <div class="input-wrapper">
                  <input
                    :class="{ hasError: this.emailError }"
                    :value="email"
                    @change="logUserEmail"
                    @input="updateEmail"
                    placeholder="Email"
                    type="email"
                  />
                  <small class="input-error" v-if="this.emailError">{{
                    this.emailError
                  }}</small>
                </div>

                <div class="input-wrapper">
                  <input
                    :class="{ hasError: this.userNameError }"
                    :value="user.name"
                    @change="logUserName"
                    @input="updateUserName"
                    placeholder="Введите имя и фамилию"
                    type="text"
                  />
                  <small class="input-error" v-if="this.userNameError">{{
                    this.userNameError
                  }}</small>
                </div>

                <div class="input-wrapper">
                  <input
                    :value="user.phone"
                    @input="updateUserPhone"
                    placeholder="Телефон"
                    type="text"
                    v-mask="setting.currency === '₽' ? '+7 (###) ###-##-##' : '+375 (##) ###-##-##'"
                  />
                  <span class='input-phone-desc'>Телефон необходим для связи в экстренных случаях</span>
                </div>


                <div class="input-wrapper checkbox-wrapper">
                  <input
                    :value="user.subscription"
                    @change="updateSubscription"
                    class="hidden-check"
                    id="subscription"
                    style="display: none"
                    type="checkbox"
                  />
                  <label class="check" for="subscription">
                    <svg height="18px" viewBox="0 0 18 18" width="18px">
                      <path
                        d="M1,3.5 L1,3.5 C1,2 2,1 3.5,1 L14.5,1 C16,1 17,2 17,3.5 L17,14.5 C17,16 16,17 14.5,17 L3.5,17 C2,17 1,16 1,14.5 L1,4.5"
                      ></path>
                      <polyline points="1 9 7 14 15 4"></polyline>
                    </svg>
                    <span>
                      Я хочу еженедельно узнавать о новых фильмах, спектаклях и
                      концертах</span
                    >
                  </label>
                </div>

              </div>
            </div>

            <div
              v-if="
                setting.donationShow &&
                  (!session.Hall ||
                    !session.Hall.HallType ||
                    session.Hall.HallType.Name !== 'Мероприятия') &&
                    user.paymentType !== 'pushkin'
              "
              class="step-box donation-step"
            >
              <div class="step-box-label">
                2. {{ setting.donationTitle || 'Поддержать кинотеатр' }}
              </div>

              <p
                v-html="
                  setting.donationDescr ||
                    'Мы благодарны каждому, кто поддержит кинотеатр'
                "
              ></p>

              <!-- <div v-if="setting.donationDescr">
                <p v-html="setting.donationDescr"></p>
              </div>
              <div v-else>
                <p>Мы благодарны каждому, кто поддержит кинотеатр</p>
              </div> -->

              <div class="step-box-inputs">
                <div class="variants-donation">
                  <label
                    v-for="(donationMoneySize,
                    index) in setting.donationMoney.split(' ')"
                    v-bind:key="index"
                    @click="selectDonationSizes(donationMoneySize)"
                  >
                    {{ donationMoneySize }} {{ setting.currency }}
                  </label>
                </div>
                <span class="and">или</span>
                <div class="input-wrapper">
                  <input
                    :value="cart.donations"
                    id="donations"
                    @input="onChangeInputDonationSizes"
                    placeholder="Введите сумму"
                    type="number"
                    @keypress="onlyNumber"
                  />
                </div>
              </div>
            </div>

            <div class="step-box" v-if="Number(cart.sum)">
              <div class="step-box-label">
                {{
                  `${
                    setting.donationShow &&
                    (!session.Hall ||
                      !session.Hall.HallType ||
                      session.Hall.HallType.Name !== 'Мероприятия') &&
                      user.paymentType !== 'pushkin'
                      ? '3'
                      : '2'
                  }. Способ оплаты`
                }}
              </div>
              <div class="payment-type-list select-list">
                <div class="payment-type-item-wrapper" style="grid-template-columns: 1fr 1fr 44px">
                  <div
                    :class="{ selected: isSelectedPayment('online') }"
                    @click="setPaymentType('online')"
                    class="payment-type-item"
                  >
                    <div class="content">
                      <div class="name">Банковская карта</div>
                    </div>
                  </div>

                  <div
                    v-if="isPushkinShow"
                    :class="{ selected: isSelectedPayment('pushkin'), 'button-hover': cart.tickets.length !== 1 || (session.IsEvent && !user.isAuthorized)}"
                    @click="setPaymentType('pushkin')"
                    class="payment-type-item"
                  >
                    <div class="content">
                      <div class="name">Пушкинская карта</div>
                    </div>
                    <div class='tooltip-payment-pushkin'>{{tooltipPushkinText}}</div>
                  </div>
                </div>

                <div
                  :key="accountId"
                  style="width: 100%"
                  v-for="accountId in customer.accountsList"
                  v-if="
                    customer.accounts &&
                      setting.isBonusAvailable &&
                      user.gender &&
                      user.birthday &&
                      user.name &&
                      user.phone && !isSelectedPayment('pushkin')"
                >
                  <AccountButton :accountId="accountId" />
                </div>

                <div
                  class="payment-type-item"
                  v-if="
                    user.isAuthorized &&
                      customer.accounts &&
                      setting.isBonusAvailable &&
                      (!user.gender ||
                        !user.birthday ||
                        !user.name ||
                        !user.phone)
                  "
                >
                  <!-- {{log({link: linkOnSiteWithWidget, text: "tut"})}} -->
                  <div class="content">
                    <div class="name">
                      Для списания бонусов
                      <a
                        :href="linkOnSiteWithWidget + 'user/cabinet'"
                        target="_blank"
                        style="text-decoration: underline; color: #fff"
                        >заполните профиль на сайте</a
                      >
                    </div>
                  </div>
                </div>

                <div class="payment-method-item-wrapper">
                  <div
                    class="payment-type-item-wrapper"
                    v-if="false && user.isAuthorized && user.card.id"
                  >
                    <div
                      :class="{ selected: user.paymentWithBonuses }"
                      @click="setPaymentWithBonuses(false, user.card.balance)"
                      class="payment-type-item pti-bonus"
                    >
                      <div class="content">
                        <div class="name">Бонусы ПремьерЗала:</div>
                        <div class="discount-flat">
                          {{ user.card.balance }} {{ setting.currency }} (Остаток:
                          {{ getLeftBonuses() }} {{ setting.currency }})
                        </div>
                      </div>

                      <!-- <div class="additional">
                                              <div class="text"> Скидка + участие в Акции</div>
                                            </div> -->
                    </div>
                    <div
                      @click="toggleBonusSlider"
                      class="change-bonus"
                      v-if="!bonusSliderShown && user.card.balance"
                    >
                      <svg
                        height="528.899px"
                        id="Capa_1"
                        style="enable-background: new 0 0 528.899 528.899"
                        version="1.1"
                        viewBox="0 0 528.899 528.899"
                        width="528.899px"
                        x="0px"
                        xml:space="preserve"
                        xmlns="http://www.w3.org/2000/svg"
                        xmlns:xlink="http://www.w3.org/1999/xlink"
                        y="0px"
                      >
                        <g>
                          <path
                            d="M328.883,89.125l107.59,107.589l-272.34,272.34L56.604,361.465L328.883,89.125z M518.113,63.177l-47.981-47.981
                          c-18.543-18.543-48.653-18.543-67.259,0l-45.961,45.961l107.59,107.59l53.611-53.611
                          C532.495,100.753,532.495,77.559,518.113,63.177z M0.3,512.69c-1.958,8.812,5.998,16.708,14.811,14.565l119.891-29.069
                          L27.473,390.597L0.3,512.69z"
                          />
                        </g>
                      </svg>
                    </div>
                    <div
                      :class="{ 'bonus-picker_shown': bonusSliderShown }"
                      class="bonus-picker"
                    >
                      <vue-slider
                        :interval="1"
                        :lazy="true"
                        :max="user.maxBonuses"
                        :min="0"
                        :tooltip="'always'"
                        :tooltip-placement="'bottom'"
                        @change="applyBonuses"
                        v-model="cart.usedBonuses"
                      ></vue-slider>
                    </div>
                  </div>

                  <div
                    @click="showModalCard"
                    class="payment-type-item"
                    v-if="
                      !user.isAuthorized &&
                        !customer.accountsList.length &&
                        setting.isBonusAvailable
                    "
                  >
                    <div class="content">
                      <div class="name">
                        Зарегистрироваться или авторизоваться
                      </div>
                    </div>
                  </div>

                  <div
                    class="payment-type-item"
                    v-if="
                      user.isAuthorized &&
                        !customer.accountsList.length &&
                        setting.isBonusAvailable &&
                        user.createdAt.getTime() + 1800 * 1000 >
                          new Date().getTime()
                    "
                  >
                    <div class="content">
                      <div class="name">
                        Бонусная карта будет выпущена в течение 5 минут
                      </div>
                    </div>
                  </div>

                  <div
                    class="payment-type-item"
                    v-if="
                      user.isAuthorized &&
                        !customer.accountsList.length &&
                        setting.isBonusAvailable &&
                        user.createdAt.getTime() + 1800 * 1000 <=
                          new Date().getTime()
                    "
                  >
                    <div class="content">
                      <div class="name">У вас нет бонусной карты</div>
                    </div>
                  </div>


                </div>

                <div class='text-after-payment-type' v-if='!user.isAuthorized && session.IsEvent && session.PushkinId'>
                  Для покупки билета по Пушкинской карте необходимо зарегистрироваться или авторизоваться
                </div>


              </div>
            </div>
          </form>
        </div>
        <div class="cart-next" v-if="this.user.paymentType">
          <div @click="makeOrder" class="basket-btn">
            <span class="btn-icon"></span>
            <span class="btn-label">{{ submitBtnText }}</span>
          </div>
          <div class="agreement-link">
            Нажимая кнопку «Оплатить», вы соглашаетесь
            <a @click.prevent="showUserAgreement" href="#" target="_blank"
              >пользовательским соглашением</a
            >.
          </div>
        </div>
      </div>
    </div>
    <ModalCard />
    <Registration />
    <UserAgreement />
    <WarningModal
      v-bind:icon="warningImage"
      v-bind:title="warningTitle"
      v-bind:text="warningText"
    />
    <WarningModalBuy />
    <WarningPushkinModal  />
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import { types } from '@/types';
import Timer from '@/components/Timer';
import ModalCard from '@/components/ModalCard';
import Registration from '@/components/Registration';
import UserAgreement from '@/components/UserAgreement';
import VueSlider from 'vue-slider-component';
import 'vue-slider-component/theme/material.css';
import AccountButton from './AccountButton';
import WarningModal from '@/components/WarningModal';
import WarningModalBuy from '@/components/WarningModalBuy';
import { mask } from 'vue-the-mask';
import WarningPushkinModal from '@/components/WarningPushkinModal';

export default {
  name: 'Buy',
  directives: { mask },

  updated () {
    if ((this.cart.bar.length || this.cart.donations) && this.user.paymentType === 'pushkin') {
      this.$modal.show('pushkin-modal')
    }
  },

  computed: {
    ...mapState([
      'cart',
      'session',
      'theatre',
      'movie',
      'user',
      'setting',
      'customer',
    ]),
    ...mapState({
      email: state => state.user.email,
      name: state => state.user.name,
      subscription: state => state.user.subscription,
    }),
    ...mapGetters(['total']),

    submitBtnText() {
      return Number(this.cart.sum) ? 'Перейти к оплате' : 'Получить';
    },
    isPushkinShow() {
      return this.session.PushkinId
    },
    tooltipPushkinText() {
      if (this.session.IsEvent) {
        if (!this.user.isAuthorized) return 'Для покупки необходимо авторизоваться'

        return 'По пушкинской карте можно приобрести только 1 билет'
      }

      return 'По пушкинской карте можно приобрести только 1 билет'
    }
  },

  components: {
    AccountButton,
    ModalCard,
    Registration,
    UserAgreement,
    Timer,
    VueSlider,
    WarningModal,
    WarningPushkinModal,
    WarningModalBuy
  },

  mounted() {
    console.log('isEvent', this.session.IsEvent)
    // this.$modal.show('warning-modal-buy')

    if ((this.cart.bar.length || this.cart.donations) && this.user.paymentType === 'pushkin') {
      this.$modal.show('pushkin-modal')
    }

    this.$store.dispatch('fetchCustomerAccounts');

    if (!this.user.ticketOrderId) {
      this.$router.push('hall');
    }

    if (
      this.setting.notification3Show &&
      this.session.Format &&
      (this.session.Format.Name == '3D' || !this.setting.notification3Only3d)
    ) {
      this.warningImage = this.setting.notification3Image;
      this.warningTitle = this.setting.notification3Title;
      this.warningText = this.setting.notification3Descr;
      this.$modal.show('warning-modal');
    }
  },

  data() {
    return {
      linkOnSiteWithWidget: document.referrer,
      emailError: false,
      userNameError: false,
      bonusSliderShown: false,
      usedBonuses: 0,
      maxBonuses: 0,
      authFormShown: false,
      warningImage: '',
      warningTitle: '',
      warningText: '',
      isOpenPushkinModal: false
    };
  },

  methods: {
    log: m => console.log(m),
    onlyNumber (e) {
      let keyCode = (e.keyCode ? e.keyCode : e.which);
      if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) { // 46 is dot
        e.preventDefault();
      }
    },
    onChangeInputDonationSizes(e) {
      if (e.target.value >= 0) {
        this.$store.commit(types.SET_DONATION_SIZE, e.target.value);
      }
    },

    selectDonationSizes(donationSize) {
      this.$store.commit(types.SET_DONATION_SIZE, donationSize);
    },

    goBack() {
      this.$store.dispatch('logRoute', {
        changes: 'Переход на страницу Бара',
        status: 'down',
      });
      if (this.user.barOrderId) {
        this.$store.dispatch('cancelBarReserve', {
          theareId: this.$route.params.theareId,
        });
      }
      window.history.length > 1 ? this.$router.go(-1) : this.$router.push('/');
    },

    /** @deprecated */
    calculateMaxBonuses() {},

    updateEmail(e) {
      this.updateProperty('user', 'email', e.target.value);
      this.validateEmail();
    },

    validateEmail() {
      if (!this.user.email) {
        this.emailError = 'Необходимо заполнить email';
        return false;
      }

      const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if (!re.test(this.user.email)) {
        this.emailError = 'Некорректный ввод email';
        return false;
      }

      this.emailError = false;
      return true;
    },

    updateUserPhone(e) {
      this.updateProperty('user', 'phone', e.target.value);
    },

    updateUserName(e) {
      this.updateProperty('user', 'name', e.target.value);
      this.validateUserName();
    },

    validateUserName() {
      if (!this.user.name) {
        this.userNameError = 'Необходимо заполнить имя';

        return false;
      }

      this.userNameError = false;
      return true;
    },

    updateSubscription(e) {
      this.updateProperty('user', 'subscription', e.target.checked);
    },

    updateProperty(stateObject, stateObjectProp, value) {
      //debugger
      this.$store.commit(types.UPDATE_PROP_VALUE, {
        stateObject: stateObject,
        stateObjectProp: stateObjectProp,
        value: value,
      });
    },

    getTotalPrice(price, count) {
      return price * count;
    },

    showUserAgreement() {
      this.$modal.show('user-agreement');
    },

    hideUserAgreement() {
      this.$modal.hide('user-agreement');
    },

    setPaymentType(paymentType) {
      if (paymentType === 'pushkin') {
        if (this.cart.tickets.length !== 1 || (this.session.IsEvent && !this.user.isAuthorized) ) {
          return false
        }

        this.$store.commit(types.UNSELECT_CUSTOMER_ACCOUNTS);
        this.$store.commit(types.UNPICKED_CUSTOMER_ACCOUNTS);
        this.$store.commit(types.CALCULATE_CART);
      }

      this.user.paymentType = paymentType
    },

    setPaymentWithBonuses(force = false, bonuses = 0) {
      this.$store.commit(types.CHANGE_PAYMENT_WITH_BONUSES, { force, bonuses });
    },

    isSelectedPayment(paymentType) {
      return this.user.paymentType === paymentType;
    },

    isValidEmail() {
      return !this.emailError;
    },

    isValidUserName() {
      return !this.userNameError;
    },

    logUserEmail() {
      this.$store.dispatch('logUser', {
        changes: 'Пользователь ввел email: "' + this.user.email + '"',
        status: 'up',
      });
    },

    logUserName() {
      this.$store.dispatch('logUser', {
        changes: 'Пользователь ввел ФИО: "' + this.user.name + '"',
        status: 'up',
      });
    },

    makeOrder: async function () {

        if (this.validateEmail() && this.validateUserName()) {
          if (this.session.IsEvent && this.user.paymentType === 'pushkin') {
            if (!this.user.isAuthorized) {
              this.$modal.show('modal-card')
              return
            }

            try {
              const customerAccounts = await this.$store.dispatch('fetchCustomerAccounts');
              if (!customerAccounts.length) {
                throw new Error('Empty list customer accounts')
              }
            } catch (e) {
              this.$modal.show('warning-modal-buy')
              return
              console.log('Произошла ошибка, попробуйте позже')
            }
          }

          if (typeof window.ym != 'undefined') {
            // eslint-disable-next-line no-undef
            ym(52995523,'reachGoal','buy')
          }


          const createOrder = await this.$store.dispatch('createOrder', {
            theatreId: this.$route.params.theatreId,
            theatreSessionId: this.$route.params.session,
            roistatVisit: this.$route.query.roistatVisit,
          });

          // eslint-disable-next-line no-undef
          dataLayer.push({ ecommerce: null });  // очистка уровня данных.
          // eslint-disable-next-line no-undef
          dataLayer.push({
              'ecommerce': {
                'currencyCode': 'RUB',
                'checkout': {
                  'actionField': { 'step': 1 },
                  'products': [
                    ...this.cart.tickets.map(ticket => (
                      {
                        'id': ticket.id,              // где film_id это id фильма или товара.
                        'name': ticket.name,          // где film_name это название фильма или товара.
                        'price': ticket.price,      // где ticket_price это цена за билет или товар.
                        'category': this.movie.Genres.join(', '),  // где category_name это название категории фильма.
                        'brand': this.theatre.NameFull,           // где cinema это название кинотеатра.
                        'variant': this.session.DateTime,      // где date-time это дата и время фильма.
                        'quantity': '1'
                      }
                    )),
                    ...this.cart.bar.map(barItem => (
                      {
                        'id': barItem.productId,              // где film_id это id фильма или товара.
                        'name': barItem.name,          // где film_name это название фильма или товара.
                        'price': barItem.price,      // где ticket_price это цена за билет или товар.
                        'category': this.movie.Genres.join(', '),  // где category_name это название категории фильма.
                        'brand': this.theatre.NameFull,           // где cinema это название кинотеатра.
                        'variant': this.session.DateTime,      // где date-time это дата и время фильма.
                        'quantity': barItem.count
                      }
                    ))
                  ]
                },
                'event': 'gtm-ee-event',
                'gtm-ee-event-category': 'Enhanced Ecommerce',
                'gtm-ee-event-action': 'Checkout Step 1',
                'gtm-ee-event-non-interaction': 'False'
              }
            });

          // eslint-disable-next-line no-undef
          dataLayer.push({ ecommerce: null });  // очистка уровня данных.
          // eslint-disable-next-line no-undef
          dataLayer.push({
              'ecommerce': {
                'currencyCode': 'RUB',
                'checkout': {
                  'actionField': { 'step': 2, 'option': 'payment_option' }, // где payment_option это способ оплаты.
                  'products': [
                    ...this.cart.tickets.map(ticket => (
                      {
                        'id': ticket.id,              // где film_id это id фильма или товара.
                        'name': ticket.name,          // где film_name это название фильма или товара.
                        'price': ticket.price,      // где ticket_price это цена за билет или товар.
                        'category': this.movie.Genres.join(', '),  // где category_name это название категории фильма.
                        'brand': this.theatre.NameFull,           // где cinema это название кинотеатра.
                        'variant': this.session.DateTime,      // где date-time это дата и время фильма.
                        'quantity': '1'
                      }
                    )),
                    ...this.cart.bar.map(barItem => (
                      {
                        'id': barItem.productId,              // где film_id это id фильма или товара.
                        'name': barItem.name,          // где film_name это название фильма или товара.
                        'price': barItem.price,      // где ticket_price это цена за билет или товар.
                        'category': this.movie.Genres.join(', '),  // где category_name это название категории фильма.
                        'brand': this.theatre.NameFull,           // где cinema это название кинотеатра.
                        'variant': this.session.DateTime,      // где date-time это дата и время фильма.
                        'quantity': barItem.count
                      }
                    ))
                  ]
                },
                'event': 'gtm-ee-event',
                'gtm-ee-event-category': 'Enhanced Ecommerce',
                'gtm-ee-event-action': 'Checkout Step 2',
                'gtm-ee-event-non-interaction': 'False'
              }
            });
        }




    },

    getLeftBonuses() {
      return (
        this.user.card.balance -
        (this.cart.spentBonuses.bar + this.cart.spentBonuses.tickets)
      );
    },

    toggleBonusSlider() {
      this.bonusSliderShown = !this.bonusSliderShown;
    },

    applyBonuses() {
      this.setPaymentWithBonuses(true, this.cart.usedBonuses);
      this.toggleBonusSlider();
    },

    showModalCard() {
      this.$modal.show('modal-card');
    },

    getNoun(number, one, two, five) {
      let n = Math.abs(number);
      n %= 100;
      if (n >= 5 && n <= 20) {
        return number + ' ' + five;
      }
      n %= 10;
      if (n === 1) {
        return number + ' ' + one;
      }
      if (n >= 2 && n <= 4) {
        return number + ' ' + two;
      }
      return number + ' ' + five;
    },
  },
};
</script>

<style lang="scss">
%circle-btn {
  box-sizing: border-box;
  overflow: hidden;
  padding: 0 10px;
  height: 40px;
  font-size: 16px;
  line-height: 22px;
  text-align: center;
  color: #fff;
  cursor: pointer;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  position: absolute;
  top: 10px;
  padding: 0;
  width: 42px;
  height: 42px;
  border: 2px solid #fff;
  border-radius: 100%;
  opacity: 0.3;
  cursor: pointer;
  justify-content: center;
  transition: 0.15s ease-in-out;

  &:hover {
    opacity: 1;
  }
}

.buy {
  background-color: #24262c;
  color: #fff;
  background-repeat: no-repeat;
  background-position: 50% 50%;
  background-size: cover;
  display: flex;
  flex-direction: column;

  &-header {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: center;
    align-items: center;
    font-size: 21px;
    color: #fff;
    padding: 0 86px 0 80px;
    height: 65px;
    border-bottom: 1px solid #fff3;
    overflow: hidden;
    box-sizing: border-box;
    position: relative;
    flex-shrink: 0;

    .logo {
      display: none;
      width: 166px;
      height: 25px;
    }

    .timer {
      display: flex;
      flex-direction: column;
      flex-wrap: nowrap;
      justify-content: center;
      align-items: center;
      white-space: nowrap;
      justify-content: space-between;
      width: 210px;
      white-space: normal;

      &-label {
        text-transform: uppercase;
        padding: 0 7px 0 0;
        font-size: 9px;
        line-height: 11px;
        letter-spacing: 0.06em;
        margin-bottom: 2px;
        padding: 0;
        letter-spacing: 1px;
        color: #fffc;
      }

      &-time {
        font-size: 17px;
        line-height: 21px;
        color: #fff;
        letter-spacing: 0.1em;
      }
    }

    .contact {
      display: none;
      position: absolute;
      right: 90px;
      top: 15px;

      &-label {
        text-transform: uppercase;
        font-size: 10px;
        line-height: 12px;
        letter-spacing: 1px;
        color: #fff;
        color: #fffc;
        margin-bottom: 2px;
      }

      &-number {
        font-size: 17px;
        line-height: 20px;
        font-weight: 500;
        letter-spacing: 0.5px;
        color: #fff;
      }
    }

    .button-back {
      @extend %circle-btn;
      left: 15px;

      .btn-icon {
        // width: 26px;
        // height: 26px;
        background-position: 50% 50%;
      }
    }

    .button-close {
      @extend %circle-btn;
      right: 15px;

      .btn-icon {
        // width: 26px;
        // height: 26px;
        background-position: 50% 50%;
      }
    }
  }

  &-body-wrapper {
    position: relative;
    display: flex;
    flex-direction: column;
    width: 100%;
    margin: 0 6px 20px;

    .label {
      font-size: 15px;
      margin-bottom: 10px;
      text-transform: uppercase;
      line-height: 13px;
      letter-spacing: 0.077em;
      color: #0d76ff;
    }
  }

  &-body {
    display: flex;
    flex-wrap: wrap;
    box-sizing: border-box;
    padding: 0;
    flex-grow: 1;
  }

  &-session {
    &-wrapper {
      box-sizing: border-box;
      padding: 15px 15px 22px;
      height: 100%;
      min-height: 146px;
      color: #fff;
      background-color: #000;
      background-repeat: no-repeat;
      background-position: 50% 50%;
      background-size: cover;
      border-radius: 10px 10px 0 0;
      flex-direction: column;
      flex-wrap: nowrap;
      justify-content: space-between;
      align-content: center;
      display: flex;
    }

    &-title {
      font-size: 16px;
      line-height: 19px;
    }

    &-tags {
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      justify-content: flex-start;
      align-content: flex-start;
      align-items: flex-start;

      .tag {
        margin: 3px 6px 0 0;
        padding: 3px 6px 2px;
        width: auto;
        background: #fff9;
        border-radius: 4px;
        font-size: 11px;
        line-height: 13px;
        color: #000000b3;
        box-sizing: border-box;
        display: block;
        font-weight: 500;
        text-align: left;
        cursor: default;
      }
    }

    &-name {
      margin: 8px 0 0;
      font-size: 20px;
      line-height: 24px;
    }
  }
}

.cart {
  &-wrapper {
    background: #fff;
    border-radius: 0 0 10px 10px;
    flex: 1 0 auto;
    display: flex;
    flex-direction: column;
    flex-wrap: nowrap;
    justify-content: space-between;
    align-items: stretch;
    align-content: flex-start;
    position: relative;
    overflow: hidden;

    &-inner {
      padding: 15px 15px 0;
      margin-top: 19px;
      flex: 1 1 auto;
      position: relative;

      &:before {
        position: absolute;
        content: '';
        right: 0;
        top: 0;
        left: 0;
        height: 15px;
        z-index: 2;
        transform: rotate(180deg);
        /* Permalink - use to edit and share this gradient: http://colorzilla.com/gradient-editor/#ffffff+0,ffffff+100&0+0,1+84 */
        background: -moz-linear-gradient(
          top,
          rgba(255, 255, 255, 0) 0%,
          rgba(255, 255, 255, 1) 84%,
          rgba(255, 255, 255, 1) 100%
        );
        /* FF3.6-15 */
        background: -webkit-linear-gradient(
          top,
          rgba(255, 255, 255, 0) 0%,
          rgba(255, 255, 255, 1) 84%,
          rgba(255, 255, 255, 1) 100%
        );
        /* Chrome10-25,Safari5.1-6 */
        background: linear-gradient(
          to bottom,
          rgba(255, 255, 255, 0) 0%,
          rgba(255, 255, 255, 1) 84%,
          rgba(255, 255, 255, 1) 100%
        );
        /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
        filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#00ffffff', endColorstr='#ffffff', GradientType=0);
        /* IE6-9 */
      }

      &:after {
        position: absolute;
        content: '';
        right: 0;
        bottom: 0;
        left: 0;
        height: 20px;
        /* Permalink - use to edit and share this gradient: http://colorzilla.com/gradient-editor/#ffffff+0,ffffff+100&0+0,1+84 */
        background: -moz-linear-gradient(
          top,
          rgba(255, 255, 255, 0) 0%,
          rgba(255, 255, 255, 1) 84%,
          rgba(255, 255, 255, 1) 100%
        );
        /* FF3.6-15 */
        background: -webkit-linear-gradient(
          top,
          rgba(255, 255, 255, 0) 0%,
          rgba(255, 255, 255, 1) 84%,
          rgba(255, 255, 255, 1) 100%
        );
        /* Chrome10-25,Safari5.1-6 */
        background: linear-gradient(
          to bottom,
          rgba(255, 255, 255, 0) 0%,
          rgba(255, 255, 255, 1) 84%,
          rgba(255, 255, 255, 1) 100%
        );
        /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
        filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#00ffffff', endColorstr='#ffffff', GradientType=0);
        /* IE6-9 */
      }
    }

    &:after {
      content: '';
      position: absolute;
      bottom: 0;
      left: 50%;
      transform: translate(-50%, 70%);
      width: 80px;
      border-radius: 50%;
      height: 80px;
      background-color: #0d76ff;
      -webkit-box-shadow: inset 0px 5px 10px 0px rgba(0, 0, 0, 0.35);
      -moz-box-shadow: inset 0px 5px 10px 0px rgba(0, 0, 0, 0.35);
      box-shadow: inset 0px 5px 10px 0px rgba(0, 0, 0, 0.35);
    }
  }

  &-scrollable {
    padding: 0;
  }

  &-items {
    margin-bottom: 20px;
  }

  &-group {
    .list {
      margin-bottom: 20px;
    }

    .item {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 10px;
      color: #777;
      font-size: 14px;

      &_result {
        font-weight: bold;
      }

      &.item_bonuses {
        color: #39a700;
      }

      .position {
        padding-right: 5px;
      }

      .dots {
        height: 10px;
        border-bottom: 1px dotted #0000004d;
        flex: 1 0 15px;
      }

      .price {
        flex: 0 0 auto;
        padding-left: 8px;
      }
    }
  }

  &-total {
    margin: 26px 0 0;
    font-size: 22px;
    text-align: right;
    color: #000000;
    display: flex;
    justify-content: flex-end;
    padding: 0 30px;
    align-items: center;

    &-label.label {
      margin-bottom: 0;
      font-size: 18px;
      line-height: normal;
      margin-right: 10px;
    }

    &-price {
      font-size: 18px;
      line-height: normal;
    }
  }

  &-promo {
    padding: 11px 15px 30px;

    .promo-btn {
      display: flex;
      flex-direction: row;
      flex-wrap: nowrap;
      margin: 0 0 10px;
      padding: 0 5px;
      height: 42px;
      background: #0d76ff;
      background: #0d76ff26;
      border-radius: 4px;
      font-weight: 400;
      font-size: 16px;
      line-height: 17px;
      color: #0d76ff;
      flex: 1 1 100%;
      box-sizing: border-box;
      overflow: hidden;
      padding: 0 10px;
      height: 40px;
      font-size: 16px;
      line-height: 22px;
      text-align: center;
      align-items: center;
      justify-content: center;
      cursor: pointer;
    }
  }
}

.theatre {
  &-wrapper {
    margin-bottom: 15px;

    .name {
      font-size: 15px;
      margin-bottom: 4px;
      color: #000;
      font-weight: 400;
      line-height: 19px;
    }

    .address {
      font-size: 14px;
      color: #777;
      font-weight: 400;
      line-height: 19px;
      margin-bottom: 5px;
    }
  }
}

.payment-wrapper {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  .cart-next {
    position: relative;
    margin-bottom: 15px;

    .agreement-link {
      position: absolute;
      bottom: -15px;
      width: 100%;
      margin: 0;
      font-size: 11px;
      line-height: 12px;
      color: #fff;
      color: #fff6;
      text-align: center;

      a {
        color: #fff;
        color: #fff9;
        text-decoration: underline;
      }
    }
  }
}

.payer-contact {
  display: flex;

  form {
    width: 100%;
    display: flex;
    flex-direction: column;
  }
}

.payer-contact-form {
  height: 100%;
}

.step-box {
  padding: 12px 15px 14px;
  /* border: 1px solid #fff;
  border: 1px solid #ffffff1a; */
  border: 1.5px solid #777575;
  border-radius: 8px;
  color: #fff;
  margin-bottom: 10px;
  display: flex;
  flex-direction: column;

  &-label {
    margin: 0 0 16px;
    padding: 0 0 0 1px;
    font-size: 14px;
    line-height: 16px;
    letter-spacing: 0.034em;
    color: #fff;
  }

  .input-wrapper {
    width: 100%;
    margin-bottom: 15px;

    input[type='text'],
    input[type='number'],
    input[type='email'],
    input[type='password'] {
      border: none;
      outline: none;
      background-color: #fff;
      border-radius: 25px;
      padding: 10px 20px;
      font-size: 18px;
      box-sizing: border-box;
      width: 100%;
      border: 2px solid transparent;

      &.hasError {
        border: 2px solid rgba(222, 12, 12, 0.65);
      }
    }

    .input-error {
      color: rgba(222, 12, 12, 1);
      text-align: center;
      margin-top: 5px;
      justify-self: center;
      display: block;
      font-size: 85%;
    }
  }

  .checkbox-wrapper {
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: flex-start;
    align-items: stretch;
    align-content: flex-start;
    display: flex;
    flex: 0 1 auto;
    margin: 0 0 16px;
    font-size: 11px;
    line-height: 12px;
    letter-spacing: 0;
    text-align: left;
    color: #fff;
    color: #fff9;
    height: 20px;
  }

  &-inputs {
    flex-flow: row wrap;
    width: 100%;
    display: flex;
  }
}

.payment-type {
  &-list {
    display: -ms-flexbox;
    display: flex;
    -ms-flex-flow: row wrap;
    flex-flow: row wrap;
    -ms-flex-pack: start;
    justify-content: flex-start;
  }

  &-item {
    padding: 0 16px;
    height: 40px;
    border: 2px solid #fff;
    border-radius: 100px;
    font-size: 14px;
    line-height: 14px;
    text-align: left;
    color: #fff;
    cursor: pointer;
    display: -ms-flexbox;
    display: flex;
    flex-direction: column;
    flex-wrap: nowrap;
    justify-content: center;
    align-items: stretch;

    &-wrapper {
      position: relative;
      margin: 0 10px 10px 0;
      display: grid;
      grid-template-columns: 1fr 44px;
      grid-gap: 10px;

      .change-bonus {
        height: 16px;
        width: 100%;
        background-color: #fff;
        height: 44px;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 25px;
        opacity: 0.95;

        &:hover {
          opacity: 1;
        }

        svg {
          z-index: 2;
          width: 16px;
          height: 100%;
          fill: #0d76ff;
        }
      }
    }

    .content {
      display: flex;
      flex-direction: row;
      flex-wrap: nowrap;
      justify-content: flex-start;
      align-items: flex-start;

      .name {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }

      .discount-flat {
        flex: 0 0 auto;
        padding: 0 0 0 5px;
        white-space: nowrap;
        color: #39a700;
      }
    }

    &.selected {
      color: #000;
      background: #fff;
      opacity: 1;
    }

    .additional {
      display: flex;
      flex-direction: row;
      flex-wrap: nowrap;
      justify-content: flex-start;
      align-items: flex-start;

      .text {
        height: 10px;
        font-size: 10px;
        line-height: 10px;
        color: #b3cae8;
      }
    }
  }
}

.check {
  cursor: pointer;
  position: relative;
  margin: auto;
  -webkit-tap-highlight-color: transparent;
  transform: translate3d(0, 0, 0);
  display: flex;
  align-items: center;

  span {
    display: block;
    margin-left: 10px;
  }

  svg {
    position: relative;
    z-index: 1;
    fill: none;
    stroke-linecap: round;
    stroke-linejoin: round;
    stroke: #c8ccd4;
    stroke-width: 1.5;
    transform: translate3d(0, 0, 0);
    transition: all 0.2s ease;
    min-width: 18px;
    min-height: 18px;

    path {
      stroke-dasharray: 60;
      stroke-dashoffset: 0;
    }

    polyline {
      stroke-dasharray: 22;
      stroke-dashoffset: 66;
    }
  }

  &:hover {
    svg {
      stroke: #0d76ff;
    }
  }
}

.hidden-check:checked + .check svg {
  stroke: #0d76ff;

  path {
    stroke-dashoffset: 60;
    transition: all 0.3s linear;
  }

  polyline {
    stroke-dashoffset: 42;
    transition: all 0.2s linear;
    transition-delay: 0.15s;
  }
}

@media (min-width: 768px) {
  .buy {
    &-header {
      .logo {
        display: block;
      }

      .contact {
        display: block;
      }
    }

    &-body {
      padding: 15px;

      &-wrapper {
        padding: 0 25px 0 0;
        flex: 0 0 335px;
        margin: 0;
      }
    }

    &-wrapper {
      flex: 0 0 335px;
      padding: 0 25px 0 0;
      height: 100%;
    }

    &-session {
      &-wrapper {
        padding: 15px 30px 22px;
        flex-basis: 225px;
        min-height: auto;
      }

      &-name {
        font-size: 15px;
        line-height: 18px;
      }
    }
  }
  .cart {
    &-wrapper {
      margin-bottom: 0;

      &-inner {
        padding: 0 15px 0 30px;
      }
    }

    &-scrollable {
      padding: 10px 10px 0 0;
      overflow-y: auto;
      max-height: 25vh;
      transform: translateZ(0);
      -webkit-backface-visibility: hidden;
      backface-visibility: hidden;
    }

    &-promo {
      padding: 11px 30px 40px;
    }
  }
  .step-box {
    margin: 0 0 15px;
    padding: 14px 16px;
    border-radius: 10px;

    .input-wrapper {
      margin: 0 8px 10px 0;
      flex: 0 1 285px;
    }

    .checkbox-wrapper {
      align-items: center;
      margin: 0 0 12px;
      max-width: 310px;
      font-size: 11px;
      line-height: 14px;
      height: 40px;
    }
  }
  .payment-type-list {
    flex: 1 0 auto;
    -ms-flex-line-pack: baseline;
    align-content: baseline;
    margin-bottom: 20px;
  }
}

.pti-bonus {
  width: calc(100% - 85px) !important;
}

.bonus-picker {
  position: absolute;
  width: 100%;
  top: 0;
  height: 44px;
  background: #fff;
  border-radius: 25px;
  opacity: 0.95;
  padding-top: 15px;
  padding-left: 15px;
  padding-right: 15px;
  box-sizing: border-box;
  display: none;
  z-index: 1;

  &_shown {
    display: block;
  }
}

.vue-slider-dot-tooltip-inner {
  background-color: #0d76ff;
}

.vue-slider-rail {
  background-color: #a5c9ff;
}

.vue-slider-process {
  background-color: #0d76ff;
}

.vue-slider-dot-handle {
  background-color: #0d76ff;
}

.vue-slider-dot-handle::after {
  background-color: rgba(153, 176, 208, 0.68);
}

@media only screen and (max-height: 480px) {
  .basket-btn {
    margin-bottom: 15px;
  }
}

@media only screen and (max-width: 768px) {
  .cart {
    &-scrollable {
      max-height: none !important;
    }
  }
}

.donation-step a {
  color: #ff8000;
  opacity: 0.9;
  transition: all 0.5s;
  &:hover,
  &:active,
  &:focus {
    opacity: 1;
  }
}

@media only screen and (max-width: 480px) {
  .payment-wrapper .cart-next {
    padding-bottom: 30px;
    margin-bottom: 25px;
  }

  .basket-btn {
    width: 95%;
    height: 42px;
    margin: 0 auto;
  }

  .payment-wrapper .cart-next .agreement-link {
    bottom: -5px;
    padding: 0 10px;
    box-sizing: border-box;
  }

  .payment-type-item-wrapper {
    margin: 0 0 15px 0;
    width: 100%;
  }

  .payment-type-item.selected {
    width: auto;
  }

  .payment-type-item .content .name {
    text-align: center;
    width: 100%;
  }

  .payment-type-item-wrapper.with-pencil .payment-type-item .content .name {
    width: auto;
  }

  .payment-method-item-wrapper {
    width: 100%;
  }
}

.donation-step {
  label {
    background: #ff8000;
    border-radius: 4px;
    line-height: 32px;
    font-family: Roboto;
    font-style: normal;
    font-weight: bold;
    font-size: 16px;
    text-align: center;
    letter-spacing: -0.02em;
    color: #ffffff;
    display: inline-block;
    box-sizing: border-box;
    margin: 8px 16px 8px 0;
    min-width: 70px;
    padding: 0 8px;
  }

  .step-box-inputs {
    display: flex;
    align-items: center;
    margin-top: 16px;
  }

  .and {
    color: #919295;
    margin-top: 8px;
    margin-bottom: 8px;
    margin-right: 10px;
  }

  .step-box-inputs {
    .input-wrapper {
      input {
        background-color: #464646;
        border: 2px solid #919295;
        box-sizing: border-box;
        border-radius: 4px;
        padding: 6px 10px;
        font-size: 16px;
        margin-top: 8px;
        margin-bottom: 8px;
        color: #fff;
        &::-webkit-outer-spin-button,
        &::-webkit-inner-spin-button {
          -webkit-appearance: none;
          margin: 0;
        }
        &[type='number'] {
          -moz-appearance: textfield;
        }
      }
    }
  }
}

.step-box.donation-step {
  .input-wrapper {
    margin: 0;
  }
}

.input-phone-desc {
  font-size: 11px;
  line-height: 14px;
  display: block;
  margin-top: 12px;
  margin-left: 8px;
  color: #fff9;
}


.tooltip-payment-pushkin {
  display: none;
  position: absolute;
  top: -3.5rem;
  right: 0;
  background: #0d76ff;
  padding: 0.5rem;
  border-radius: .5rem;
  width: 140%;
  color: #fff;
  text-align: center;
}

.payment-type-item.button-hover {
  position: relative;

  &:hover .tooltip-payment-pushkin{
    display: block;
  }
}

.text-after-payment-type {
  width: 100%;
  margin-top: 1rem;
}


</style>
